import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EdiPreviewService } from '../services/edipreview.service';

@Component({
  selector: 'app-web-results',
  templateUrl: './web-results.component.html',
  styleUrls: ['./web-results.component.scss']
})
export class WebResultsComponent {

  @Output() onDownload: EventEmitter<any> = new EventEmitter();
  @Input() results: any[] = [];
  @Input() isInvoiceResults: boolean = false;
  @Input() isStatusResults: boolean = false;
  @Input() isInboundResults: boolean = false;
  statCdReason: string = '';

  constructor(
    private ediPreviewService: EdiPreviewService){}

  download(result: any): void {
    this.onDownload.emit(result);
  }

  getStatusCdToolTip(statusType: string): void {
    // Implement logic to get status code tooltip
    this.statCdReason = `Reason for ${statusType}`;
  }
  ngOnInit() {
  }

  getFormattedReferenceNumbers(referenceNumbers: { [key: string]: string[] }): { key: string, values: string }[] {
    return Object.entries(referenceNumbers).map(([key, values]) => ({
      key,
      values: values.join(', ')
    }));
  }


  preview(result: any) {
    this.ediPreviewService.preview(result);  // Correct way to call the method

  }

}
